const BrightlyAdrFilter = (path: string): boolean => {
  const lowerPath = path.toLowerCase();
  if (lowerPath === 'template.md' || lowerPath === 'readme.md') {
    return false;
  }

  return path.endsWith('.md');
}

export { BrightlyAdrFilter }
